/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_Save_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Asset metadata updated" |
*
* @param {Iconik_Metadata_Save_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_save_success_toast = /** @type {((inputs?: Iconik_Metadata_Save_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_Save_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Asset metadata updated")
	if (locale === "de") return /** @type {LocalizedString} */ ("Asset metadata updated")
	if (locale === "it") return /** @type {LocalizedString} */ ("Asset metadata updated")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Asset metadata updated")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asset metadata updated")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Asset metadata updated")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Asset metadata updated")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Asset metadata updated")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Asset metadata updated")
	return /** @type {LocalizedString} */ ("Asset metadata updated")
});